import api, { request } from '../../api';
import { IErrorsStore } from '../errors/store';
import { IActionGroup, IStore } from '../index';
import { IPage, IPagesStore } from './store';

export interface IPagesActions extends IActionGroup {
  create: (clubId: number, body: Partial<IPage>) => { pages?: IPagesStore; errors?: IErrorsStore };
  edit: (clubId: number, body: Partial<IPage>) => { pages?: IPagesStore; errors?: IErrorsStore };
  get: (clubId: number, force?: boolean, isAdmin?: boolean) => { pages?: IPagesStore; errors?: IErrorsStore };
  remove: (clubId: number, pageId: number) => { pages?: IPagesStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  create: async (state: IStore, clubId: number, body: Partial<IPage>) => {
    const response = await request.post(`${api.admin.pages(clubId)}`, body);

    if (response.error) {
      return { errors: { pages: { msg: 'Error Creating new Page.' } } };
    }

    const newPage: IPage = response;

    return {
      pages: {
        ...state.pages,
        [clubId]: [...(state.pages[clubId] || []), newPage]
      }
    };
  },
  edit: async (state: IStore, clubId: number, body: Partial<IPage>) => {
    const response = await request.patch(`${api.admin.pages(clubId)}${body.id}`, body);

    if (response.error) {
      return { errors: { pages: { msg: 'Error Creating new Page.' } } };
    }

    const newPage: IPage = response;

    return {
      pages: {
        ...state.pages,
        [clubId]: state.pages[clubId].filter(p => p.id !== newPage.id).concat([newPage])
      }
    };
  },
  get: async (state: IStore, clubId: number, force?: boolean, isAdmin?: boolean) => {
    if (state.pages[clubId] && !force) {
      return { pages: state.pages };
    }

    const response = isAdmin ? await request.get(api.admin.pages(clubId)) : await request.get(api.pages(clubId));

    if (response.error) {
      return { errors: { pages: { msg: 'Error retrieving the Club Pages.' } } };
    }

    const pages: IPage[] = response;

    return {
      pages: {
        ...state.pages,
        [clubId]: pages
      }
    };
  },
  remove: async (state: IStore, clubId: number, pageId: number) => {
    const response = await request.delete(`${api.admin.pages(clubId)}${pageId}`);

    if (response.error) {
      return { errors: { pages: { msg: 'Error deleting the page.' } } };
    }

    return {
      pages: {
        ...state.pages,
        [clubId]: state.pages[clubId].filter(p => p.id !== pageId)
      }
    };
  }
};

export default actions;
